module.exports = __webpack_public_path__ + "img/intro-title-fr.39a9c872.png";